module.exports = __webpack_public_path__ + "static/media/ex3.78aa0ebf.jpg";